import React, { useState } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { FiLock } from "react-icons/fi";
import DefaultLayout from "../../../layout/vendor/DefaultLayout";
import { useNavigate } from "react-router-dom";
import Success from "../../../components/Success";

const ResetPasswordModal = () => {
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const handleSuccess = () => {
    setShowSuccess(true);
  };

  const handleBackToLogin = () => {
    navigate("/vendor/login"); // Navigate to the login page
  };

  return (
    <>
      <Container
        fluid
        className="d-flex justify-content-center align-items-center vh-100"
      >
        <Card className="phone-modal">
          <Card.Body className="phone-modal__body">
            {/* Lock Icon */}
            <div className="text-center mb-3">
              <div className="phone-modal__icon-wrapper">
                <FiLock className="phone-modal__lock-icon" />
              </div>
            </div>

            {/* Title */}
            <h6 className="phone-modal__title">Reset Password</h6>

            {/* Subtitle */}
            <p className="phone-modal__subtitle">Enter your new password</p>

            {/* Phone Input */}
            <Form>
              <Form.Group className="mb-4">
                <Form.Label className="phone-modal__form-label">
                  New Password
                </Form.Label>

                <Form.Control
                  type="password"
                  placeholder="Enter new password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label className="phone-modal__form-label">
                  Confirm Password
                </Form.Label>

                <Form.Control
                  type="password"
                  placeholder="Enter confirm password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </Form.Group>

              <div className="d-flex gap-3">
                <Button
                  variant="primary"
                  className="flex-grow-1"
                  onClick={handleSuccess}
                >
                  Reset Password
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Container>
      <Success
        show={showSuccess}
        close={() => setShowSuccess(false)}
        message={`Your password has been updated successfully`}
      />
    </>
  );
};

export default ResetPasswordModal;
